<script>
import _find from 'lodash/find'
import { getGA4EcommerceNullPayload, getGA4EcommerceBasketActionPayload } from '~/lib/util/gtmGA4'
import { sendSSAPIPageView, sendSSAPIViewContent, createFBContentCategory, sendSSAPIAddToCart, createUniqueFBEventId } from '~/lib/util/fb'

export default {
  methods: {
    pushPageView() {
      // Facebook Event Deduplication
      const eventId = createUniqueFBEventId('PageView')

      // Facebook Pixel ViewCategory Tracking
      this.$fb &&
        this.$fb.track('ViewCategory', {
          content_name: this.dataUI.name,
          content_category: this.dataUI.name,
          content_type: 'product_group',
          content_ids: this.productsForFB
        })

      // FB v12.0
      const eventSourceUrl = `${this.$config.baseURL}${this.$route.fullPath}`

      // Facebook Server-side API PageView
      sendSSAPIPageView({ context: this, parameters: { eventId, eventSourceUrl } })
    },

    pushFBViewItemEvent() {
      // Facebook Event Deduplication
      const eventId = createUniqueFBEventId('PageView')
      const eventIdViewContent = createUniqueFBEventId('ViewContent')

      // FB v12.0
      const eventSourceUrl = `${this.$config.baseURL}${this.$route.fullPath}`

      // Facebook Server-side API PageView
      sendSSAPIPageView({ context: this, parameters: { eventId, eventSourceUrl } })

      // Facebook Server-side API ViewContent
      console.log('MAG=', this.dataUI.magazine)
      const content = {
        name,
        category: createFBContentCategory({ magazine: this.dataUI.magazine }),
        ids: this.offersForFB(),
        idsAndPrice: this.offersForFBSSAPI()
      }
      sendSSAPIViewContent({ context: this, content, parameters: { eventId: eventIdViewContent, eventSourceUrl } })
    },

    pushGTMAndFBAfterButtonClick({ action, item, isDefaultOffer }) {
      // Facebook Event Deduplication
      const eventId = createUniqueFBEventId('AddToCart')

      // Customer email address
      const email = this.$store.getters['s/email']

      // GA4 events for each Basket Button's Click
      this.$config.GA4Syntax && isDefaultOffer && this.$gtm && this.$gtm.push({ event: 'add_to_cart_mobile_topoffer' })
      this.$config.GA4Syntax && this.$config.GA4FireEcommerceNull && this.$gtm && this.$gtm.push(getGA4EcommerceNullPayload())
      this.$config.GA4Syntax && this.$gtm && this.$gtm.push(getGA4EcommerceBasketActionPayload({ action, item, eventId, email }))

      // FB v12.0
      const eventSourceUrl = `${this.$config.baseURL}${this.$route.fullPath}`

      // Facebook Server-side API AddToCart
      sendSSAPIAddToCart({ context: this, item, parameters: { eventId, eventSourceUrl } })
    },

    offersForFB() {
      if (!this.dataUI.offers) {
        return []
      }

      const print = (this.dataUI?.offers?.PRINT && this.dataUI?.offers?.PRINT.map(prod => prod.sku + '')) || []
      const international = (this.dataUI?.offers?.INTERNATIONAL && this.dataUI?.offers?.INTERNATIONAL.map(prod => prod.sku + '')) || []
      const singleIssues = (this.dataUI?.offers?.SINGLE_ISSUES && this.dataUI?.offers?.SINGLE_ISSUES.map(prod => prod.sku + '')) || []

      if (print || international || singleIssues) {
        return [...print, ...international, ...singleIssues]
      } else {
        return []
      }
    },
    offersForFBSSAPI() {
      if (!this.dataUI?.offers) {
        return []
      }

      const print =
        (this.dataUI?.offers?.PRINT &&
          this.dataUI?.offers?.PRINT.map(prod => {
            return { sku: prod.sku + '', price: prod.price }
          })) ||
        []
      const international =
        (this.dataUI?.offers?.INTERNATIONAL &&
          this.dataUI?.offers?.INTERNATIONAL.map(prod => {
            return { sku: prod.sku + '', price: prod.price }
          })) ||
        []
      const singleIssues =
        (this.dataUI?.offers?.SINGLE_ISSUES &&
          this.dataUI?.offers?.SINGLE_ISSUES.map(prod => {
            return { sku: prod.sku + '', price: prod.price }
          })) ||
        []

      if (print || international || singleIssues) {
        return [...print, ...international, ...singleIssues]
      } else {
        return []
      }
    },
    defaultOffer() {
      if (!this.dataUI.offers) {
        return {}
      }

      let df =
        this.dataUI.offers.PRINT &&
        _find(this.dataUI.offers.PRINT, i => {
          return i.productId === this.dataUI.magazine.cheapestOfferId
        })

      if (!df) {
        df =
          this.dataUI.offers.INTERNATIONAL &&
          _find(this.dataUI.offers.INTERNATIONAL, i => {
            return i.productId === this.dataUI.magazine.cheapestOfferId
          })
      }
      if (!df) {
        df =
          this.dataUI.offers.SINGLE_ISSUES &&
          _find(this.dataUI.offers.SINGLE_ISSUES, i => {
            return i.productId === this.dataUI.magazine.cheapestOfferId
          })
      }
      return df
    }
  }
}
</script>
